import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Container, Typography, CircularProgress } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import PageHead from '../components/PageHead';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Redirect to profile after 3 seconds
    const timer = setTimeout(() => {
      navigate('/profile', { 
        state: { 
          subscriptionSuccess: true,
          message: 'Your subscription has been successfully upgraded!' 
        } 
      });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="sm">
      <PageHead 
        title="Subscription Upgraded" 
        description="Your AutoBlogPilot subscription has been successfully upgraded"
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
        }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: 80,
            color: 'success.main',
            mb: 3,
          }}
        />
        <Typography variant="h4" gutterBottom>
          Subscription Upgraded Successfully!
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Thank you for upgrading your subscription. You will be redirected to your profile shortly...
        </Typography>
        <CircularProgress size={24} sx={{ mt: 2 }} />
      </Box>
    </Container>
  );
};

export default SubscriptionSuccess; 